//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

<template>
  <DIV class='content-wrapper'>
  <div v-if="serverData.loadingDataStatus.mainCommonData != serverData.loadingDataStatus.types.LOADED" class="loading-text">
    Подождите, загружаются общие данные
  </div>
  <div v-else-if="serverData.loadingDataStatus.places != serverData.loadingDataStatus.types.LOADED" class="loading-text">
    Подождите, загружаются данные по событиям
  </div>
  <div v-else style="width:100vw; float:left">

    <div class="datalist">
    <div class="datalist-scroll">

    <div style="width:100%; font-size:5px;">&nbsp;</div>

    <div v-if="(activeUser != null)" class="place place-dashed-border">
      <div class="place-image" style="text-align:center">
        <router-link to="/place-edit" class="place-edit-link link">
          <i class="fas fa-plus-circle" style="font-size:48px;"></i><br><br>
          <span style="font-size:20px">Добавить место</span>
        </router-link>
      </div>
      <div class="place-info" style="background:#D9E0E7">&nbsp;</div>
    </div>

    <div v-for="(place, key) in filteredData" :key="place.val.id" @click="dataRowOnSelect(place)" class="place">

      <div class="place-image" :style="{'background-image': 'url(' + serverData.imagesGetURL(place.val.images[0]) + ')'}">
        &nbsp;
      </div>

      <DIV class="place-info">

      <div style="width:100%; padding:0px 0 0 0; float:left;">
        <div class="place-name">{{place.val.name}}</div>
      </div>

      <div style="width:100%; padding:10px 0 0 0; float:left;">
        <!--div class="place-prop">Адрес:</div-->
        <div class="place-prop">{{place.val.city}}, {{place.val.address}}</div>
      </div>

      <div v-if="place.val.description != ''" style="width:100%; padding:10px 0 0px 0; float:left;">
        <!--div class="place-prop">Описание:</div-->
        <div class="place-prop">{{place.val.description}}</div>
      </div>

      </DIV>

    </div>

    </div>
    </div>

  </div>

  </DIV>
</template>

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

<script>
import { mapGetters } from 'vuex'

// import Event from './Event.vue'

import serverData from '@/store/serverData'

import arrayTools from '../technical/arrayTools/arrayTools.js'

export default {
  components: { },
  data () {
    return {
      data: [],
      // filteredRecords: [],

      filterValue: '',
      // filterStatusValue: '',

      serverData: serverData, // to make access from UI template
      loadingSpinner: false
    }
  },
  computed: {
    ...mapGetters([
      'appSettings',
      'activeUser'
    ]),
    filteredData: function () {
      var filtered = []
      // var startDate = new Date(Date.now())
      // startDate = new Date(startDate.getFullYear(), startDate.getMonth(), startDate.getDate(), 0, 0, 0)

      for (var i = 0; i < this.data.length; i++) {
        var place = this.data[i]
        filtered.push(place)
      }

      arrayTools.sort(filtered, function (a, b) {
        var res = a.val.name.toLowerCase().localeCompare(b.val.name.toLowerCase())
        // var res = window.mystrcmp(a.val.name.toLowerCase(), b.val.name.toLowerCase())
        if (res === 0) return false
        if (res > 0) return true; else return false
      })

      return filtered
    }
  },
  created: function () {
    this.data = serverData.places // если перезаугрузка данной страницы то тут ничего еще не загружено и пусто. получаем через event placesChanged
  },
  methods: {
    dataRowOnSelect (value) {
      this.$router.push({name: 'place', params: {id: value.val.id}})
    },
    isActiveUserAdmin () {
      if ((this.activeUser != null) && ((this.activeUser.group === 0) || (this.activeUser.group === 1))) return true // суперпользователь или админ
      return false
    }
  }
}
</script>

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

<style scoped>
.content-wrapper{
  margin: 0px 0px 0px 0px;
  padding: 0px;
  font-family: "Open Sans", sans-serif;
  font-weight: 100;
}
.loading-text {
  font-family: "Open Sans", sans-serif;
  font-weight: 100;
  font-size: 20px;
  padding: 20px 20px 20px 20px;
}
.datalist{
  height: 100%;
  width: 100%;
  margin: 0px 0px 0px 0px;
  padding: 0px;
  background: #D9E0E7;
}
.datalist-scroll {
  overflow-x: hidden;
  overflow-y: scroll;
  height: calc(100vh - 50px);
}
@media screen and (min-width: 1000px) {
  .datalist {
    background: #D9E0E7;
  }
}
.place {
  width: 100%;
  /* max-width: 1000px; */
  margin: 0px 25px 25px 0px;
  cursor: pointer;
  float:left;
}
@media screen and (min-width: 950px) {
  .place {
    max-width: calc((100% - 50px) / 2);
  }
}
@media screen and (min-width: 1440px) {
  .place {
    max-width: calc((100% - 75px) / 3);
  }
}
@media screen and (min-width: 1900px) {
  .place {
    max-width: calc((100% - 100px) / 4);
  }
}
.place-dashed-border {
  margin: 0 24px 21px 1px;
  border: 2px dashed #ccc;
  border-radius: 20px;
  cursor:default
}
.place-edit-link {
  width:200px;
  margin:200px 0 0 calc((100% - 200px) / 2);
  float:left;
}
@media screen and (max-width: 950px) {
  .place-dashed-border {
    max-height: 200px;
  }
  .place-edit-link {
    margin-top: 50px;
  }
}
.link {
  color: #778 !important;
  text-decoration: none !important;
  cursor: pointer !important;
}
.link:hover {
  color: #808aa0 !important;
  text-decoration: none !important;
}
.place-image {
  width: 100%;
  height: 66vw;
  max-height: 400px;
  background-size: cover;
  background-position: center;
  border-radius: 20px 20px 0px 0px;
  border: solid 0px #fff;
  float: left;
}
.place-info {
  width: 100%;
  height: 175px;
  padding: 0;
  background: #fff;
  border-radius: 0px 0px 20px 20px;
  border: solid 0px #fff;
  float: left;
}
.place-name {
  /* position: relative;
  top: calc(100% - 95px);
  z-index: 2;
  padding: 13px 35px 17px 12px;
  opacity: 0.85;
  background: #fff;
  color: #222; */
  padding: 10px 25px 0px 25px;
  color: #222;
  font-family: "Open Sans", sans-serif;
  font-weight: 600;
  font-size: 18px;
  float:left;
}
.place-prop {
  width: 100%;
  padding: 7px 25px 0px 25px;
  color: #666;
  font-family: "Open Sans", sans-serif;
  font-weight: 400;
  font-size: 15px;
  float:left;
}
.text-align-right {
  text-align:right;
}
</style>

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////



// WEBPACK FOOTER //
// Places.vue?2c4bd24e